<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
    <!--  查询表单  -->
    <div class="factor-config-container">
      <el-form :inline="true" :model="search">
        <el-form-item label="加和因子名称">
          <el-input v-model="search.factorName"
                    clearable size="small"
                    style="width: 200px"
                    placeholder="请输入加和因子"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search.status" placeholder="请选择状态"
            clearable size="small" style="width: 200px">
            <el-option
              v-for="option in statusOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="orange" size="small" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button type="primary" size="small" @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>

  <template #toolbar>
    <el-button type="orange" size="small" @click="handleAddModel" icon="el-icon-plus">新建</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <!--  数据表格  -->
      <el-table
        ref="table" height="100%"
        border :data="list"
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%">
        <el-table-column label="序号" width="80" align="center" fixed>
          <template v-slot="{$index}">{{ formatTableIndex($index) }}</template>
        </el-table-column>
        <el-table-column prop="factorName" label="加和因子名称" align="center"/>
        <el-table-column prop="deviceIds" label="监测仪名称" align="center">
          <template v-slot="{row}">
            {{deviceOptions.find((opt) => opt.value === row.deviceIds) ? deviceOptions.find((opt) => opt.value === row.deviceIds).label : '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="factorIds" show-overflow-tooltip label="监测因子" align="center">
          <template v-slot="{row}">
            {{ receiverPars(row.factorIds) }}
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="说明" align="center" />
        <el-table-column prop="createTime" label="创建日期" align="center"/>
        <el-table-column prop="status" width="120" label="状态" align="center">
          <template v-slot="{row}">
            {{statusOptions.find((opt) => opt.value === row.status) ? statusOptions.find((opt) => opt.value === row.status).label : '--'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template v-slot="{row}">
            <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button v-if="row.status === '0'" size="mini" type="text" @click="updateStatus(row.id,'1')">启用</el-button>
            <el-button v-else size="mini" type="text" style="color: #f56c6c;" @click="updateStatus(row.id,'0')">禁用</el-button>
            <el-button size="mini" type="text" style="color: #f56c6c;" @click="handleDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--  对话框  -->
      <el-dialog
        :title="dialogTitle"
        top="10vh"
        show-overflow-tooltip
        :close-on-click-modal="false"
        :visible.sync="dialog.model"
        width="720px"
        @close="handleDialogClose">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
          <el-form-item label="加和因子名称" prop="factorName">
            <el-input size="small" v-model="form.factorName" placeholder="请输入加和因子的名称"></el-input>
          </el-form-item>
          <el-form-item label="监测仪名称" prop="deviceIds">
            <el-select v-model="form.deviceIds" size="small" style="width: 100%" placeholder="请选择监测仪">
              <el-option
                v-for="option in deviceOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="监测因子" prop="factorIds">
            <div style="background-color: #fafafa; border-radius: 5px;padding: 8px">
              <div class="radio-group-container">
                <span class="radio-label">快速选择：</span>
                <el-button size="mini" @click="handleSelectAll" round>全选</el-button>
                <el-button size="mini" @click="handleSelectNo" round>反全选</el-button>
                <el-button size="mini" @click="handleSelect36" round>36种因子</el-button>
                <el-button size="mini" @click="handleSelect57" round>57种因子</el-button>
                <el-button size="mini" @click="handleSelect64" round>64种因子</el-button>
              </div>
              <div class="checkbox-group-container">
                <el-checkbox-group v-model="form.factorIds" class="custom-checkbox-group">
                  <el-checkbox
                    v-for="item in factorOptions"
                    :key="item.id"
                    :label="item.id"
                    class="custom-checkbox-item">
                    {{ item.cnName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="说明" prop="remarks">
            <el-input type="textarea" size="small" v-model="form.remarks"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" :loading="dialog.loading" @click="addConfig">提交</el-button>
          </div>
        </template>
      </el-dialog>
    </data-wrapper>
  </template>
  <!--  分页  -->
  <template #footer>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNum"
      :page-sizes="[20, 50, 100, 200, 500]"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next"
      background
      style="float:right">
    </el-pagination>
  </template>
</layout-content>
</template>

<script>
import LayoutContent from '../../../components/Layout/Content'
import DataWrapper from '../../../components/Data/DataWrapper'
import BaseStore from '../../../components/BaseStore'
// 快选因子常量
const select36FactorIds = [
  '2001', '2002', '2003', '2004', '2005', '2006', '2008', '2009', '2012', '2014',
  '2015', '2016', '2021', '2038', '2045', '2047', '2048', '2050', '2051', '2054',
  '2055', '2057', '2058', '2059', '2060', '2064', '2066', '2068', '2072', '2075',
  '2079', '2084', '2085', '2089', '2097', '2138'
]
const select57FactorIds = [
  '2001', '2002', '2003', '2004', '2005', '2006', '2008', '2009', '2010', '2012',
  '2013', '2014', '2015', '2016', '2018', '2020', '2021', '2022', '2023', '2024',
  '2025', '2026', '2036', '2037', '2038', '2039', '2041', '2042', '2043', '2044',
  '2045', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055',
  '2056', '2057', '2058', '2059', '2060', '2062', '2063', '2064', '2065', '2066',
  '2067', '2068', '2069', '2070', '2071', '2090', '2138'
]
const select64FactorIds = [
  '2001', '2002', '2003', '2004', '2005', '2006', '2008', '2009', '2010', '2012',
  '2013', '2014', '2015', '2016', '2018', '2020', '2021', '2022', '2023', '2024',
  '2025', '2026', '2036', '2037', '2038', '2039', '2041', '2042', '2043', '2044',
  '2045', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055',
  '2056', '2057', '2058', '2059', '2060', '2062', '2063', '2064', '2065', '2066',
  '2067', '2068', '2069', '2070', '2071', '2072', '2075', '2079', '2084', '2085',
  '2089', '2090', '2097', '2138'
]
// 因子ID-名称映射
const createFactorIdMap = (factorList) => {
  const map = new Map()
  if (!Array.isArray(factorList)) return map
  factorList.forEach(item => {
    if (item.id && item.cnName) {
      map.set(item.id, item.cnName)
    }
  })
  return map
}

export default {
  name: 'FactorConfig',
  routeInfo: {
    label: '因子配置',
    icon: 'fa fa-eye'
  },
  mixins: [BaseStore],
  components: {DataWrapper, LayoutContent},
  data () {
    return {
      search: {
        factorName: '',
        status: ''
      },
      statusOptions: [
        {value: '0', label: '禁用'},
        {value: '1', label: '启用'}
      ],
      deviceOptions: [
        {value: 'amagc5000,expec2000,expec2000ms,thermo5900c', label: 'VOCs自动监测仪'}
      ],
      form: {
        factorName: '',
        deviceIds: 'amagc5000,expec2000,expec2000ms,thermo5900c',
        factorIds: [],
        remarks: ''
      },
      rules: {
        factorName: [
          { required: true, message: '请输入加和因子名称', trigger: 'blur' }
        ],
        deviceIds: [
          { required: true, message: '请选择监测仪', trigger: 'change' }
        ],
        factorIds: [
          { type: 'array', required: true, message: '请至少选择一个因子', trigger: 'change' }
        ]
      },
      list: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      dialog: {
        title: 'add',
        model: false,
        loading: false
      },
      factorOptions: [],
      factorIdMap: new Map()
    }
  },
  computed: {
    dialogTitle () {
      return this.dialog.title === 'edit' ? '编辑配置' : '添加配置'
    }
  },
  methods: {
    // 初始化加载
    initBase () {
      this.initDefaultData()
      this.fetchData()
    },
    // 加载默认数据
    initDefaultData () {
      this.$api['FactorRuleConfig'].getFactorOptions()
        .then(res => {
          this.factorOptions = res || []
          this.factorIdMap = createFactorIdMap(this.factorOptions)
        }).catch(console.error)
    },
    // 获取数据
    fetchData () {
      this.changeLoadStatus(true)
      const params = {
        ...this.search,
        size: this.pagination.pageSize,
        current: this.pagination.pageNum
      }
      this.$api['FactorRuleConfig'].pageList(params)
        .then(res => {
          this.list = res.records || []
          this.pagination.total = res.total || 0
        })
        .catch(console.error)
        .finally(() => {
          this.changeLoadStatus(false)
        })
    },
    // 查询数据
    handleSearch () {
      this.pagination.pageNum = 1
      this.fetchData()
    },
    // 重置查询
    handleReset () {
      this.pagination.pageNum = 1
      this.search.factorName = ''
      this.search.status = ''
      this.fetchData()
    },
    // 分页数量改变
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.fetchData()
    },
    // 分页页码改变
    handleCurrentChange (currentPage) {
      this.pagination.pageNum = currentPage
      this.fetchData()
    },
    // 开启对话框
    handleAddModel () {
      this.dialog.title = 'add'
      this.show()
    },
    // 快速选择 36
    handleSelect36 () {
      this.form.factorIds = select36FactorIds
    },
    // 快速选择 57
    handleSelect57 () {
      this.form.factorIds = select57FactorIds
    },
    // 快速选择 64
    handleSelect64 () {
      this.form.factorIds = select64FactorIds
    },
    // 快速选择 全选
    handleSelectAll () {
      this.form.factorIds = this.factorOptions.map(item => item.id).filter(id => id !== undefined && id !== null && id !== '')
    },
    // 快速选择 反全选
    handleSelectNo () {
      this.form.factorIds = []
    },
    // 取消对话框
    resetForm (formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields()
        this.$refs[formName].clearValidate()
      }
    },
    // 对话框关闭处理
    handleDialogClose () {
      this.resetForm('ruleForm')
      this.hide()
      this.form = {
        factorName: '',
        deviceIds: 'amagc5000,expec2000,expec2000ms,thermo5900c',
        factorIds: [],
        remarks: ''
      }
    },
    // 提交表单
    addConfig () {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) return
        if (this.dialog.loading) return
        this.dialog.loading = true
        const params = {
          ...this.form,
          factorIds: this.form.factorIds.join(',')
        }
        let model
        if (this.dialog.title === 'add') {
          params.id = null
          model = this.$api['FactorRuleConfig'].factorRuleSave(params)
        } else {
          model = this.$api['FactorRuleConfig'].factorRuleUpdate(params)
        }
        if (model) {
          model.then(data => {
            if (data) {
              this.$notify({
                title: this.dialog.title === 'add' ? '新建成功' : '编辑成功',
                message: this.dialog.title === 'add' ? '新建因子配置保存成功' : '编辑因子配置保存成功',
                type: 'success',
                position: 'bottom-right'
              })
              this.handleDialogClose()
              this.fetchData()
            }
          })
            .catch(console.error)
            .finally(() => {
              this.dialog.loading = false
            })
        }
      })
    },
    // 开启对话框
    show () {
      this.dialog.model = true
    },
    // 关闭对话框
    hide () {
      this.dialog.model = false
    },
    // 格式化表格序号
    formatTableIndex (index) {
      return (this.pagination.pageNum - 1) * this.pagination.pageSize + index + 1
    },
    // 解析因子
    receiverPars (factorIds) {
      if (!factorIds) return '--'
      const idList = Array.from(factorIds.split(','))
      const nameList = idList.map(id => this.factorIdMap.get(id) || id)
      return nameList.join('、')
    },
    // 编辑配置
    handleEdit (row) {
      this.dialog.title = 'edit'
      this.form = {
        ...row,
        factorIds: row.factorIds ? row.factorIds.split(',') : []
      }
      this.show()
    },
    // 启用因子配置
    updateStatus (id, status) {
      const title = status === '1' ? '启用' : '禁用'
      this.$confirm(`此操作将${title}该因子配置, 是否继续?`, `${title}提示`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeLoadStatus(true)
        this.$api['FactorRuleConfig'].updFactorStatus({id, status})
          .then(() => {
            this.$notify({
              title: '成功',
              message: `配置${title}成功!`,
              type: 'success',
              position: 'bottom-right'
            })
            this.fetchData()
          })
          .catch(console.error)
          .finally(() => {
            this.changeLoadStatus(false)
          })
      }).catch(() => {})
    },
    // 删除因子配置
    handleDelete (id) {
      this.$confirm(`此操作将会把该因子配置永久删除, 是否继续?`, `删除提示`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeLoadStatus(true)
        this.$api['FactorRuleConfig'].delFactorConfig({id})
          .then(() => {
            this.$notify({
              title: '成功',
              message: `配置删除成功!`,
              type: 'success',
              position: 'bottom-right'
            })
            this.fetchData()
          })
          .catch(console.error)
          .finally(() => {
            this.changeLoadStatus(false)
          })
      }).catch(() => {})
    }
  },
  created () {
    this.initBase()
  }
}
</script>

<style lang="scss" scoped>
.factor-config-container {
  gap:12px;
  float:left;
  display:flex;
  margin-left:2em;
  margin-top: -4px;
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }
}
.radio-group-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: 32px;
}
.checkbox-group-container {
  height: 260px;  // 固定高度
  overflow-y: auto;  // 纵向滚动，横向不滚动
  box-sizing: border-box; // 高度包含边框/内边距
  &::-webkit-scrollbar {
    width: 6px; // 滚动条宽度
  }
  &::-webkit-scrollbar-thumb {
    background-color: #dcdcdc; // 滚动条滑块颜色
    border-radius: 3px; // 滑块圆角
  }
  &::-webkit-scrollbar-track {
    background-color: #f5f5f5; // 滚动条轨道颜色
  }
  .custom-checkbox-group {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05AlarmRule/02FactorConfig/index.vue